const LAT_LIMIT = 90;
const LNG_LIMIT = 180;

const isAbsent = (value) => value === null || value === undefined || value === '';

const coord = (value, limit) => {
	const n = Number(value);
	return (Number.isFinite(n) && Math.abs(n) <= limit) ? n : null;
};

const pair = (latValue, lngValue) => {
	const lat = isAbsent(latValue) ? 0 : coord(latValue, LAT_LIMIT);
	const lng = isAbsent(lngValue) ? 0 : coord(lngValue, LNG_LIMIT);
	if (lat === null || lng === null) { return null; }
	return (lat === 0 && lng === 0) ? null : { lat, lng };
};

export const resolveMapCenter = (props) => {
	const property = pair(props.latitude, props.longitude);
	const system   = pair(props.system_latitude, props.system_longitude);
	const [preferred, fallback] = props.property_latlon
		? [property, system]
		: [system, property];

	return preferred || fallback || { lat: 0, lng: 0 };
};
